var React = require('react');

function Padlock18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 7V4C5 1.79086 6.79086 0 9 0C11.2091 0 13 1.79086 13 4V7H15V18H3V7H5ZM11 4V7H7V4C7 2.89543 7.89543 2 9 2C10.1046 2 11 2.89543 11 4ZM10 12.6181V15H8V12.6181C7.69313 12.3434 7.5 11.9443 7.5 11.5C7.5 10.6716 8.17157 10 9 10C9.82843 10 10.5 10.6716 10.5 11.5C10.5 11.9443 10.3069 12.3434 10 12.6181Z","fill":"currentColor"}));
}

Padlock18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Padlock18;

Padlock18.default = Padlock18;
